/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';


export interface ReportsControllerUpdateStaticReportSectionFile$Params {

/**
 * Static report section ID.<p>A HEX string containing 24 characters, representing unique identifier string.</p>
 */
  id: string;
  
    /**
     * Binary data of the PDF file to be uploaded. The maximum size is 1mb.
     */
    body: string
}

export function reportsControllerUpdateStaticReportSectionFile(http: HttpClient, rootUrl: string, params: ReportsControllerUpdateStaticReportSectionFile$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
  const rb = new RequestBuilder(rootUrl, reportsControllerUpdateStaticReportSectionFile.PATH, 'put');
  if (params) {
    rb.path('id', params.id, {});
    rb.body(params.body, 'application/pdf');
  }

  return http.request(
    rb.build({ responseType: 'text', accept: '*/*', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return (r as HttpResponse<any>).clone({ body: undefined }) as StrictHttpResponse<void>;
    })
  );
}

reportsControllerUpdateStaticReportSectionFile.PATH = '/planning-projects/v1-preview/reports/static-report-sections/{id}/files';
